import styled from '@emotion/styled';

export const MAX_WIDTH = 34;

const HiddenItemsCount = styled.span`
  display: inline-flex;
  font-size: 1.1rem;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  min-width: 1.43rem;
  max-width: ${MAX_WIDTH}px;
  line-height: 1.43rem;
  align-items: center;
  justify-content: center;
  position: relative;
  color: ${({ theme }) => theme.palette.primary.main};
  padding-left: ${({ theme }) => theme.spacing(1)};
`;

export default HiddenItemsCount;
